"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoxyMarketService = exports.FOXY_ASSET_ID = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const investor_foxy_1 = require("@shapeshiftoss/investor-foxy");
const unchained = __importStar(require("@shapeshiftoss/unchained-client"));
const coingecko_1 = require("../coingecko/coingecko");
exports.FOXY_ASSET_ID = 'eip155:1/erc20:0xDc49108ce5C57bc3408c3A5E95F3d864eC386Ed3';
const FOX_ASSET_ID = 'eip155:1/erc20:0xc770eefad204b5180df6a14ee197d99d808ee52d';
const FOXY_ASSET_PRECISION = '18';
class FoxyMarketService extends coingecko_1.CoinGeckoMarketService {
    constructor({ providerUrls, coinGeckoAPIKey, }) {
        super({ coinGeckoAPIKey });
        this.providerUrls = providerUrls;
    }
    async findAll() {
        try {
            const assetId = exports.FOXY_ASSET_ID;
            const marketData = await this.findByAssetId({ assetId });
            return { [assetId]: marketData };
        }
        catch (e) {
            console.warn(e);
            return {};
        }
    }
    async findByAssetId({ assetId }) {
        try {
            if (assetId.toLowerCase() !== exports.FOXY_ASSET_ID.toLowerCase()) {
                console.warn('FoxyMarketService(findByAssetId): Failed to find by AssetId');
                return null;
            }
            const coinGeckoData = await super.findByAssetId({
                assetId: FOX_ASSET_ID,
            });
            if (!coinGeckoData)
                return null;
            const ethChainAdapter = new chain_adapters_1.ethereum.ChainAdapter({
                providers: {
                    ws: new unchained.ws.Client(this.providerUrls.unchainedEthereumWsUrl),
                    http: new unchained.ethereum.V1Api(new unchained.ethereum.Configuration({
                        basePath: this.providerUrls.unchainedEthereumHttpUrl,
                    })),
                },
                rpcUrl: this.providerUrls.jsonRpcProviderUrl,
            });
            // Make maxSupply as an additional field, effectively EIP-20's totalSupply
            const api = new investor_foxy_1.FoxyApi({
                adapter: ethChainAdapter,
                providerUrl: this.providerUrls.jsonRpcProviderUrl,
                foxyAddresses: investor_foxy_1.foxyAddresses,
            });
            const tokenContractAddress = investor_foxy_1.foxyAddresses[0].foxy;
            const foxyTotalSupply = await api.tvl({ tokenContractAddress });
            const supply = foxyTotalSupply;
            return {
                price: coinGeckoData.price,
                marketCap: '0',
                changePercent24Hr: coinGeckoData.changePercent24Hr,
                volume: '0',
                supply: supply === null || supply === void 0 ? void 0 : supply.div(`1e+${FOXY_ASSET_PRECISION}`).toString(),
                maxSupply: foxyTotalSupply === null || foxyTotalSupply === void 0 ? void 0 : foxyTotalSupply.div(`1e+${FOXY_ASSET_PRECISION}`).toString(),
            };
        }
        catch (e) {
            console.warn(e);
            throw new Error('FoxyMarketService(findByAssetId): error fetching market data');
        }
    }
    async findPriceHistoryByAssetId({ assetId, timeframe, }) {
        if (assetId.toLowerCase() !== exports.FOXY_ASSET_ID.toLowerCase()) {
            console.warn('FoxyMarketService(findPriceHistoryByAssetId): Failed to find price history by AssetId');
            return [];
        }
        try {
            const priceHistory = await super.findPriceHistoryByAssetId({
                assetId: FOX_ASSET_ID,
                timeframe,
            });
            return priceHistory;
        }
        catch (e) {
            console.warn(e);
            throw new Error('FoxyMarketService(findPriceHistoryByAssetId): error fetching price history');
        }
    }
}
exports.FoxyMarketService = FoxyMarketService;
